import React, {Component} from 'react';
import {List,NavBar,TextareaItem,Toast,InputItem,Modal} from 'antd-mobile';
import {cancleCityInfo,cancleCity,tobepayInfo} from "../../../../../service/cityService";
import './index.less';
import {connect} from "react-redux";
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class CityConfirm extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
           data:{},
           id:'',
           charge:'',
           notes:'',
           showModal:false,
        };
    }

    componentDidMount() {
        if(this.props.location.state.type === 'tobepay'){
            let params = {
                token: this.props.userInfo.token,
                data: {
                    "id": this.props.location.state.id,
                }
            }
            tobepayInfo(params).then((res) => {
                console.log(res)
                if(res.data.code == "0000"){
                  this.setState({
                      data:res.data.data,
                      id:res.data.data.id
                  })
                }else {
                    Toast.info(res.data.msg,3)
                }
                }).catch(function (error) {
                console.log(error);
            });
        }else{
            let params = {
                token: this.props.userInfo.token,
                data: {
                    "shuntOrderid": this.props.location.state.id,
                    "operatorType":1,
                    "isCharge":0
                }
            }
            cancleCityInfo(params).then((res) => {
                console.log(res)
                if(res.data.code == "0000"){
                  this.setState({
                      data:res.data.data,
                      id:res.data.data.id
                  })
                }else {
                    Toast.info(res.data.msg,3)
                }
                }).catch(function (error) {
                console.log(error);
            });
        }
       
    }
    infoChange=(v,key)=>{
        this.setState({
            [key]:v
        })
    }
    delete = (type) =>{
        if(type === "charge"){
            var params = {
                "token": this.props.userInfo.token,
                "data":{
                    "shuntOrderid":this.state.id,
                    "operatorType": 1,
                    "isCharge":0,
                    "otherPriceDes":this.state.notes,
                    "otherPrice":this.state.charge,
                }
             };
        }else if(type === "close"){
            var params = {
                "token": this.props.userInfo.token,
                "data":{
                    "shuntOrderid":this.state.id,
                    "operatorType": 1,
                    "isCharge":1,
                }
             };
        }
        cancleCity(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                Toast.info(this.state.type === 'charge'?'账单已发送，请等待乘客完成付款':'订单已关闭');
                setTimeout(() => {
                    this.props.history.goBack();
                }, 4000);
                }
                else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
             }).catch(function (error) {
             console.log(error);
         });
    };

    render() {
        const {data} = this.state;
        return (
            <div className="cityConfirm">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >确认账单</NavBar>
                <div className="body">
                    <div className="orderNum">订单号：{this.props.location.state.orderNum}</div>
                    <div className="content">
                        <div>
                            <span>订单里程：</span>
                            <div>{data.actualDistance}公里</div>
                        </div>
                        <div>
                            <span>里程费用：</span>
                            <div>{data.kilometerPrice}元（普通时段）</div>
                        </div>
                        <div>
                            <span>起步价格：</span>
                            <div>{data.initiatePrice}元</div>
                        </div>
                        <div>
                            <span>等待时长：</span>
                            <div>{data.waitingTime}分钟</div>
                        </div>
                        <div>
                            <span>等待费用：</span>
                            <div>{data.waitingPrice}元</div>
                        </div>
                        <div>
                            <span>空驶里程：</span>
                            <div>{data.deadheadKilometres}公里</div>
                        </div>
                        <div>
                            <span>空驶费用：</span>
                            <div>{data.deadheadPrice}元</div>
                        </div>
                        <div>
                            <span>远程里程：</span>
                            <div>{data.remoteDistance ?data.remoteDistance : 0}公里</div>
                        </div>
                        <div>
                            <span>远程费用：</span>
                            <div>{data.remoteDistancePrice ? data.remoteDistancePrice : 0}元</div>
                        </div>
                        {this.props.location.state.type !== 'tobepay' ?
                        <div>
                            <span>其它费用：</span>
                            <InputItem 
                                placeholder="请输入金额" 
                                value={this.state.charge}
                                onChange={(val) => this.infoChange(val, 'charge')}
                            ></InputItem>
                        </div>
                        : 
                        <div>
                            <span>其它费用：</span>
                            <div>{data.otherPrice}元</div>
                        </div>}
                        {this.props.location.state.type !== 'tobepay' ?
                        <div>
                            <span>备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</span>
                            <TextareaItem
                                placeholder="请输入备注内容"
                                rows={3}
                                onChange={(val) => this.infoChange(val, 'notes')}
                                value={this.state.notes}
                            />
                        </div>:
                        <div>
                        <span>备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</span>
                        <div>{data.note === '' ? '无' : data.note}</div>
                    </div>}
                        {this.props.location.state.type !== 'tobepay' ?<p>*如果在行驶过程中产生其他费用（过路费等），请在此处添加</p>:null}
                        <div className="money"><span>应付金额</span> {(Number(data.totalPrice) + Number(this.state.charge)).toFixed(2)}元</div>
                        {this.props.location.state.type !== 'tobepay' ? <p className="tips">如果当前订单不收取费用，请点击关闭订单</p> :null}
                        {this.props.location.state.type !== 'tobepay' ? <p className="tips">如果需要收取费用，请点击发送账单</p>:null}
                        {this.props.location.state.type !== 'tobepay' ? <p className="tips">请在三分钟内完成账单确认，超时后系统将自动发送账单</p>:null}
                        {this.props.location.state.type !== 'tobepay' ? <div className="btnBox">
                            <div className="btn blue" onClick={()=>this.setState({type:"charge",showModal:true})}>发送账单</div>
                            <div className="btn black" onClick={()=>this.setState({type:"close",showModal:true})}>关闭订单</div>
                        </div>:null}
                    </div>
                    <Modal
                    className="combineBillViewModal"
                    visible={this.state.showModal}
                    transparent
                    closable
                    maskClosable={true}
                    onClose={()=>this.setState({showModal:false})}
                    footer={[{ text: '否', onPress: () => {this.setState({showModal:!this.state.showModal})}},{ text: '是', onPress: () => { this.setState({showModal:!this.state.showModal});;this.delete(this.state.type)}}]}
                >
                <div className="modalTitle">
                    <div>{this.state.type === 'charge' ? '是否发送账单':'是否关闭订单'}</div>
                    <div>{this.state.type === 'charge' ? '发送给乘客让乘客进行付款':'关闭不需要收取费用'}</div>
                </div>
                </Modal>   
                </div>
                
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/changeRole/City/CityConfirm/index.js